import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import OverallTableWiseTab from "./historicalOverAll";
import LiveStatusTab from "./historicalLiveStatus";
import HistoricalData from "./historicalData";

export function HistoricalDataTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        aria-label="historical sync tabs"
        sx={{
          backgroundColor: "#f5f5f5", 
          borderBottom: "1px solid #ccc"
        }}
      >
        <Tab 
          label="OverAll Status" 
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#e0f7fa", // Background color for the active tab
              color: "#00796b", // Active text color
            }
          }} 
        />
        <Tab 
          label="Live Status" 
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#e0f7fa", // Background color for the active tab
              color: "#00796b", // Active text color
            }
          }} 
        />
        <Tab 
          label="Cleanup Status" 
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#e0f7fa", // Background color for the active tab
              color: "#00796b", // Active text color
            }
          }} 
        />
      </Tabs>

      <Box sx={{ p: 3 }}>
        {value === 0 && <OverallTableWiseTab />}
        {value === 1 && <LiveStatusTab />}
        {value === 2 && <HistoricalData />}
      </Box>
    </Box>
  );
}
